// extracted by mini-css-extract-plugin
export default {"wrapper":"ReferalLinks_wrapper__uUPKM"};